import { createSelector } from 'reselect'
import { getCompanyAccountsMap } from '../reducks/companyAccounts'
import { companyId } from './sessions'

export const companyAccount = createSelector([companyId, getCompanyAccountsMap], (cId, companyAccountsMap) => {
  const company = companyAccountsMap[cId]
  return !company ? {} : company
})

export const companyName = createSelector([companyAccount], company => company.name)

export const companyClassification = createSelector([companyAccount], company => company.classification)

export const companySize = createSelector([companyAccount], company => company.number_of_employees)

export const isCompanyProfileAiGenerated = createSelector([companyAccount], company => company.is_ai_generated_profile)

export const selectCompanyActiveSubscription = createSelector([companyAccount], company => company.active_subscription)

// TODO remove these selectors relying on static data
export const getCompany = state => state.static_data.company

export const companyDetails = createSelector([getCompany], company => {
  if (!company) return {}

  return {
    id: company.id,
    name: company.name,
    created_at: company.created_at,
    current_state: company.current_state,
  }
})

export const companyAcceptedTerms = createSelector([getCompany], company => company.accepted_terms)
